import { Sun, Moon, Menu, Bell, User, LogOut, UserCircle, ChevronDown } from "lucide-react";
import { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { AdminContext } from "./AdminLayout";
import { useUser } from "../../../contexts/UserContext";
import { ToastMessage } from "../../../Components/Utils";
import { ROUTE_PATHS } from "../../../constants/routeConstants";
import { user_profile_image_url } from "../../../Components/ImageUrls";

const MOCK_NOTIFICATIONS = [
  { id: 1, title: "New order received", message: "Order #1042 placed by John Doe.", time: "2m ago", read: false },
  { id: 2, title: "Low stock alert", message: "Product 'Air Max' has only 3 units left.", time: "15m ago", read: false },
  { id: 3, title: "New user registered", message: "sarah@example.com just signed up.", time: "1h ago", read: true },
  { id: 4, title: "Payment failed", message: "Order #1039 payment could not be processed.", time: "3h ago", read: true },
];

const TopBar = () => {
  const { dark, setDark, mobileOpen, setMobileOpen } = useContext(AdminContext);
  const { user, setUser } = useUser();
  const navigate = useNavigate();

  const [notifOpen, setNotifOpen] = useState(false);
  const [profileOpen, setProfileOpen] = useState(false);
  const [notifications, setNotifications] = useState(MOCK_NOTIFICATIONS);
  const notifRef = useRef(null);
  const profileRef = useRef(null);

  const handleLogout = () => {
    Cookies.remove("token");
    setUser(null);
    ToastMessage({ type: "success", title: "Goodbye!", message: "Logged out successfully" });
    navigate(ROUTE_PATHS.LOGIN);
  };

  const unread = notifications.filter((n) => !n.read).length;
  const defaultAvatar = `https://ui-avatars.com/api/?name=${encodeURIComponent((user?.name || "User").split(" ").slice(0, 2).join("+"))}&background=F97316&color=fff&size=128`;
  const displayAvatar = user?.user_image ? `${user_profile_image_url}${user.user_image}` : defaultAvatar;
  const markAllRead = () => setNotifications((prev) => prev.map((n) => ({ ...n, read: true })));

  useEffect(() => {
    const handler = (e) => {
      if (notifRef.current && !notifRef.current.contains(e.target)) setNotifOpen(false);
      if (profileRef.current && !profileRef.current.contains(e.target)) setProfileOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);
  return (
    <header className="bg-white mb-3 shadow-sm h-16 flex items-center justify-between px-4 transition-colors dark:bg-slate-900">
      {/* Left */}
      <div className="flex items-center gap-3">
        <button
          className="md:hidden p-2 rounded-md hover:bg-gray-100 dark:hover:bg-slate-700 transition"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle menu"
        >
          <Menu size={20} className="text-gray-700 dark:text-gray-200" />
        </button>
        <h1 className="text-sm lg:text-lg font-bold text-gray-800 dark:text-gray-100">
          Admin Panel
        </h1>
      </div>

      {/* Right */}
      <div className="flex items-center gap-2">
        {/* Dark mode */}
        <button
          onClick={() => setDark(!dark)}
          className="p-2 rounded-md hover:bg-gray-100 dark:hover:bg-slate-700 transition"
        >
          {dark ? <Sun size={18} className="text-yellow-400" /> : <Moon size={18} className="text-gray-600 dark:text-gray-300" />}
        </button>

        

        {/* Profile */}
        <div className="relative" ref={profileRef}>
          <button
            onClick={() => setProfileOpen((o) => !o)}
            className="flex items-center gap-1.5 p-1.5 rounded-md hover:bg-gray-100 dark:hover:bg-slate-700 transition"
            aria-label="Profile"
          >
            <img
              src={displayAvatar}
              className="w-8 h-8 rounded-full object-cover shadow-lg border-2 border-green-400 dark:border-green-700"
              alt="avatar"
            />
            <ChevronDown size={14} className={`text-gray-500 transition-transform duration-200 ${profileOpen ? "rotate-180" : ""}`} />
          </button>

          {profileOpen && (
            <div className="absolute right-0 top-full mt-2 w-52 bg-white dark:bg-slate-800 rounded-lg shadow-xl border border-gray-100 dark:border-slate-700 z-50 overflow-hidden">
              {/* User info */}
              <div className="px-4 py-3 border-b border-gray-100 dark:border-slate-700">
                <p className="text-sm font-semibold text-gray-800 dark:text-gray-100 truncate">{user?.name || "User"}</p>
                <p className="text-xs text-gray-400 truncate">{user?.email || ""}</p>
              </div>

              {/* Actions */}
              <ul className="py-1">
                <li>
                  <button
                    onClick={() => { setProfileOpen(false); navigate(ROUTE_PATHS.ADMIN_PROFILE); }}
                    className="w-full flex items-center gap-3 px-4 py-2.5 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-slate-700/50 transition"
                  >
                    <UserCircle size={16} className="text-gray-400" />
                    Profile
                  </button>
                </li>
                <li className="border-t border-gray-100 dark:border-slate-700">
                  <button
                    onClick={handleLogout}
                    className="w-full flex items-center gap-3 px-4 py-2.5 text-sm text-red-500 hover:bg-red-50 dark:hover:bg-red-500/10 transition"
                  >
                    <LogOut size={16} />
                    Logout
                  </button>
                </li>
              </ul>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default TopBar;
